(() => {
  const initialiseProduct = root => {
    if (root.dataset.commerceBound) return;
    root.dataset.commerceBound = 'true';
    const form = root.querySelector('[data-product-form]');
    if (!form) return;
    const button = form.querySelector('[data-add-button]');
    const label = form.querySelector('[data-add-label]');
    const select = form.querySelector('[data-variant-select]');
    const message = form.querySelector('[data-product-message]');
    const bagLink = form.querySelector('[data-view-bag]');
    const strings = JSON.parse(root.querySelector('[data-commerce-strings]').textContent);
    let submitting = false;
    const selectedAvailable = () => select ? select.selectedOptions[0]?.dataset.available === 'true' : !button.hasAttribute('data-initial-sold-out');
    if (button.disabled) button.dataset.initialSoldOut = 'true';
    const refreshVariant = () => {
      if (!select) return;
      const option = select.selectedOptions[0];
      if (!option) return;
      root.querySelector('[data-product-price]').textContent = option.dataset.price;
      const compare = root.querySelector('[data-product-compare]');
      compare.textContent = option.dataset.compare;
      compare.hidden = option.dataset.onSale !== 'true';
      const available = selectedAvailable();
      root.querySelector('[data-product-availability]').textContent = available ? strings.inStock : strings.soldOut;
      button.disabled = submitting || !available;
      label.textContent = submitting ? strings.adding : available ? strings.add : strings.soldOut;
      message.textContent = '';
      message.removeAttribute('data-error');
      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', url);
    };
    select?.addEventListener('change', refreshVariant);
    form.addEventListener('submit', async event => {
      if (!window.fetch || !window.FormData) return;
      event.preventDefault();
      if (submitting || !form.reportValidity() || !selectedAvailable()) return;
      const data = new FormData(form);
      submitting = true;
      button.disabled = true;
      if (select) select.disabled = true;
      form.setAttribute('aria-busy', 'true');
      label.textContent = strings.adding;
      message.textContent = '';
      message.removeAttribute('data-error');
      bagLink.hidden = true;
      try {
        const rootPath = window.Shopify?.routes?.root || '/';
        const response = await fetch(rootPath + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: data });
        const item = await response.json();
        if (!response.ok) throw new Error(typeof item.description === 'string' ? item.description : strings.error);
        message.textContent = strings.added;
        bagLink.hidden = false;
        try {
          const cartResponse = await fetch(rootPath + 'cart.js', { headers: { Accept: 'application/json' } });
          if (cartResponse.ok) {
            const cart = await cartResponse.json();
            document.querySelectorAll('[data-cart-count]').forEach(count => { count.textContent = cart.item_count; });
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
          }
        } catch {}
      } catch (error) {
        message.textContent = error.message || strings.error;
        message.dataset.error = 'true';
      } finally {
        submitting = false;
        if (select) select.disabled = false;
        form.removeAttribute('aria-busy');
        button.disabled = !selectedAvailable();
        label.textContent = selectedAvailable() ? strings.add : strings.soldOut;
      }
    });
  };
  const initialise = scope => scope.querySelectorAll('[data-editorial-product]').forEach(initialiseProduct);
  initialise(document);
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();

/* US-market price display only. Shopify prices and checkout amounts remain unchanged. */
(() => {
  const settingsNode = document.getElementById('JascanoCurrencySettings');
  if (!settingsNode) return;
  let config;
  try { config = JSON.parse(settingsNode.textContent); } catch { return; }
  const countryForm = document.getElementById('JascanoCountryForm');
  const countrySelect = document.getElementById('JascanoCountry');
  let automaticCountryChange = false;
  const safeGet = key => { try { return sessionStorage.getItem(key); } catch { return null; } };
  const safeSet = (key, value) => { try { sessionStorage.setItem(key, value); } catch {} };
  countryForm?.addEventListener('submit', () => {
    if (!automaticCountryChange) safeSet('jascano-country-choice', countrySelect?.value || config.country);
    const returnInput = countryForm.querySelector('[name="return_to"]');
    if (returnInput) {
      const url = new URL(location.href);
      url.searchParams.delete('country');
      returnInput.value = url.pathname + url.search + url.hash;
    }
  });
  const selectUSMarket = async () => {
    if (config.country === 'US' || !countryForm || !countrySelect || safeGet('jascano-country-choice') || safeGet('jascano-country-checked')) return;
    // Explicit market links take priority over GeoIP suggestions.
    if (new URLSearchParams(location.search).has('country')) return;
    safeSet('jascano-country-checked', 'true');
    try {
      const url = new URL(config.root + 'browsing_context_suggestions.json', location.origin);
      url.searchParams.set('country[enabled]', 'true');
      const response = await fetch(url, {credentials: 'same-origin', signal: AbortSignal.timeout(4000)});
      if (!response.ok) return;
      const data = await response.json();
      if (data.detected_values?.country?.handle !== 'US' || ![...countrySelect.options].some(o => o.value === 'US')) return;
      countrySelect.value = 'US';
      automaticCountryChange = true;
      countryForm.requestSubmit();
    } catch {}
  };
  selectUSMarket();
  // Conversion is restricted to the selected United States market in an INR store.
  if (config.country !== 'US' || config.storeCurrency !== 'INR' || config.presentmentCurrency !== 'INR') return;
  const selector = '.product-price,.qv-price,[data-product-price],[data-product-compare],.ec-item-price span,.ec-item-price s,.ec-discount,.ec-summary-row span:last-child,.ec-total span:last-child';
  const record = new WeakMap();
  const formatter = new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2});
  let quote = null;
  let pending = false;
  const referenceIsUsable = row => row && row.base === 'INR' && row.quote === 'USD' && Number.isFinite(row.rate) && row.rate > 0 && row.rate < 1 && Number.isFinite(Date.parse(row.date)) && Date.now() - Date.parse(row.date) < 10 * 86400000 && Date.parse(row.date) <= Date.now() + 86400000;
  const addNotes = () => {
    const text = quote ? 'Approximate USD prices. Checkout is charged in INR.' : 'Prices are shown in INR while USD estimates are unavailable.';
    const targets = ['.ep-price-row', '#qvPrice', '#shopCategories', '.native-collection h1', '.ec-total'];
    for (const selector of targets) {
      const target = document.querySelector(selector);
      if (!target) continue;
      let note = target.nextElementSibling;
      if (!note?.matches('[data-usd-price-note]')) {
        note = document.createElement('p');
        note.className = 'usd-price-note';
        note.dataset.usdPriceNote = '';
        target.after(note);
      }
      if (note.textContent !== text) note.textContent = text;
    }
    document.querySelectorAll('[data-usd-footer-note]').forEach(note => {
      const detail = quote ? text + ' Reference rate: ' + quote.date + '.' : text;
      if (note.textContent !== detail) note.textContent = detail;
    });
  };
  const render = () => {
    pending = false;
    if (!quote) { addNotes(); return; }
    document.querySelectorAll(selector).forEach(element => {
      if (element.childElementCount) return;
      const current = element.textContent;
      const prior = record.get(element);
      if (prior?.rendered === current) return;
      const original = current;
      const rendered = original.replace(/(?:₹|Rs\.?|INR)\s*([0-9][0-9,]*(?:\.[0-9]{1,2})?)(?:\s*INR)?/g, (_, value) => {
        const amount = Number(value.replaceAll(',', ''));
        return Number.isFinite(amount) ? formatter.format(amount * quote.rate) + ' USD' : _;
      });
      if (rendered !== original) {
        record.set(element, {original, rendered});
        element.textContent = rendered;
        element.dataset.usdEstimate = 'true';
        element.title = 'Approximate USD equivalent. Checkout is charged in INR.';
      }
    });
    addNotes();
    document.documentElement.dataset.displayCurrency = 'USD';
  };
  const schedule = () => { if (!pending) { pending = true; requestAnimationFrame(render); } };
  const start = () => {
    render();
    new MutationObserver(schedule).observe(document.body, {subtree: true, childList: true, characterData: true});
  };
  (async () => {
    let cache;
    try { cache = JSON.parse(localStorage.getItem('jascano-usd-reference') || 'null'); } catch {}
    if (referenceIsUsable(cache) && Date.now() - cache.cachedAt < 86400000) {
      quote = cache;
      start();
      return;
    }
    try {
      const response = await fetch('https://api.frankfurter.dev/v2/rate/inr/usd?providers=ecb', {credentials: 'omit', referrerPolicy: 'no-referrer', signal: AbortSignal.timeout(4000)});
      if (!response.ok) throw Error('Reference rate unavailable');
      const row = await response.json();
      if (!referenceIsUsable(row)) throw Error('Invalid reference rate');
      quote = {...row, cachedAt: Date.now()};
      try { localStorage.setItem('jascano-usd-reference', JSON.stringify(quote)); } catch {}
    } catch {
      if (referenceIsUsable(cache)) quote = cache;
      else if (referenceIsUsable(config.fallback)) quote = config.fallback;
    }
    start();
  })();
})();
